"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Banner = require("./Banner.styles");

var getDomainInUrl = function getDomainInUrl(str, customBaseUrl) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
  );

  if (!pattern.test(str)) {
    return customBaseUrl + str;
  }

  return str;
};

var Banner = function Banner(_ref) {
  var Header = _ref.Header,
      Description = _ref.Description,
      ImageUrl = _ref.ImageUrl,
      Links = _ref.Links,
      clickEvent = _ref.clickEvent,
      thirdLinkText = _ref.thirdLinkText,
      customBaseUrl = _ref.customBaseUrl;
  return /*#__PURE__*/_react["default"].createElement(_Banner.BannerWrapper, null, /*#__PURE__*/_react["default"].createElement(_Banner.BannerContent, null, /*#__PURE__*/_react["default"].createElement(_Banner.BannerHeading, null, Header), /*#__PURE__*/_react["default"].createElement(_Banner.BannerSubHeading, null, Description), /*#__PURE__*/_react["default"].createElement(_Banner.BannerAnchorWrapper, null, Links.map(function (l, i) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Banner.BannerAnchor, {
      target: "_blank",
      href: getDomainInUrl(l.Url, customBaseUrl)
    }, l.DisplayText), i >= 0 ? ' | ' : null);
  }), /*#__PURE__*/_react["default"].createElement(_Banner.BannerAnchor, {
    id: "medalliaBannerAnchor",
    onClick: function onClick() {
      return clickEvent();
    }
  }, thirdLinkText))), /*#__PURE__*/_react["default"].createElement("img", {
    src: ImageUrl,
    alt: "Banner Visual"
  }));
};

Banner.propTypes = {
  // Header text
  Header: _propTypes["default"].string.isRequired,
  // Description text
  Description: _propTypes["default"].string.isRequired,
  // Url for banner images
  ImageUrl: _propTypes["default"].string.isRequired,
  // click event handler for third link
  clickEvent: _propTypes["default"].func.isRequired,
  // text for third link in banner
  thirdLinkText: _propTypes["default"].string.isRequired,
  // domain base url
  customBaseUrl: _propTypes["default"].string.isRequired,
  // data retrieved from call to create links on banner
  Links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    DisplayText: _propTypes["default"].string.isRequired,
    Url: _propTypes["default"].string.isRequired
  })).isRequired
};
Banner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Banner",
  "props": {
    "Header": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "Description": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "ImageUrl": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "clickEvent": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "thirdLinkText": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "customBaseUrl": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "Links": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "DisplayText": {
              "name": "string",
              "required": true
            },
            "Url": {
              "name": "string",
              "required": true
            }
          }
        }
      },
      "required": true
    }
  }
};
var _default = Banner;
exports["default"] = _default;